import React from 'react';
import { observer } from 'mobx-react';

import { useHasQuickStart } from '@components/routes/entitlements';
import { GetStarted, InlineGetStarted } from '@components/routes/pages';
import { entitled } from '@components/routes/routeEntitlement';

import { useIsInlineGetStartedEnabled } from './inlineGetStartedFlag';

/**
 * `/getStarted` is the inline setup page for organization admins in workspaces with the inline
 * Get started flag on. Everyone else keeps the legacy quick start page, which only some plans have.
 * The organization, which says who is an admin, is in before any route renders: the app loads it
 * with the workspace's settings.
 */
export const GetStartedRoute = observer(() => {
  const isInlineGetStartedEnabled = useIsInlineGetStartedEnabled();

  return isInlineGetStartedEnabled ? (
    <InlineGetStarted />
  ) : (
    entitled(useHasQuickStart, <GetStarted />)
  );
});
